import axios from '@/load_axios';
import { API_HOST } from '@/constants';

const categories = {
    namespaced: true,
    state: {
        all: [],
    },
    getters: {
        id: (state) => (id) => {
            return state.all.find(category => category.id == id)
        },
        slug: (state) => (slug) => {
            return state.all.find(category => category.slug == slug)
        },
        slugs: (state) => (slugs) => {
            let categories = []
            for (let slug of slugs) {
                let category = state.all.find(c => c.slug == slug)
                if (category == null)
                    continue
                categories.push(category)
            }
            return categories
        },
    },
    mutations: {
        add(state, categories) {
            for (let category of categories) {
                const index = state.all.findIndex(storedCategory => storedCategory.id === category.id)
                if (index === -1) {
                    state.all.push(category)
                } else {
                    state.all.splice(index, 1, category)
                }
            }
        },
    },
    actions: {
        async getAll({ commit }) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/categories`)
            commit('add', res.data)
        },
        async getById({ commit }, id) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/categories/${id}`)
            commit('add', [res.data])
            return res.data
        },
        async getOne({ commit }, slug) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/categories?slug=${slug}`)
            commit('add', res.data)
            return res.data
        },
    },
}

export default categories
